import { render, staticRenderFns } from "./Statistiche.vue?vue&type=template&id=5935e87b&scoped=true&"
import script from "./Statistiche.vue?vue&type=script&lang=js&"
export * from "./Statistiche.vue?vue&type=script&lang=js&"
import style0 from "./Statistiche.vue?vue&type=style&index=0&id=5935e87b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935e87b",
  null
  
)

export default component.exports